export const DEFAULT_LIST = ['testing', 'inspection'];
